import { Column } from 'components/Blocks';

import { TaskSubTasks } from './SubTasks';
import { TaskUserInteractions } from './UserInteractions';

export function MainTaskData() {
  return (
    <Column>
      <TaskSubTasks />

      <TaskUserInteractions />
    </Column>
  );
}
